"use client";
import React, { useEffect } from "react";

// import '@fancyapps/ui/dist/fancybox/fancybox.css'
import "@fancyapps/ui/dist/fancybox.css";

import AOS from "aos";
import "aos/dist/aos.css";
import { toast } from "react-toastify";

export default function InitEffects() {
  useEffect(() => {
    const timer = setTimeout(() => {
      import("@fancyapps/ui").then(({ Fancybox }) => {
        Fancybox.bind("[data-fancybox]", {
          Thumbs: {
            autoStart: false,
            type: "modern",
          },
          Carousel: { infinite: true },
          Toolbar: true,
        });
      });

      return () => Fancybox.destroy();
    }, 500);

    AOS.init({
      duration: 1000,
      once: true,
    });

    return () => clearTimeout(timer);
  }, []);

  return null;
}
